const AppEvents = {
    i: 0,
    events: {
        'ADD_TO_CART': {},
        'COMPLETE_REGISTRATION': {},
        'CONTACT': {},
        'CUSTOMIZE_PRODUCT': {},
        'FIND_LOCATION': {},
        'INITIATE_CHECKOUT': {},
        'PURCHASE': {},
        'SEARCH': {},
        'VIEW_CONTENT': {},
        'SET_USER_ID': {},
    },
    extraCookies: [],
    calledEvents: {
        'ADD_TO_CART': [],
        'COMPLETE_REGISTRATION': [],
        'CONTACT': [],
        'CUSTOMIZE_PRODUCT': [],
        'FIND_LOCATION': [],
        'INITIATE_CHECKOUT': [],
        'PURCHASE': [],
        'SEARCH': [],
        'VIEW_CONTENT': [],
        'SET_USER_ID': [],
    },
    getNextLoadId() {
        if(this.i>0){
            return window.loadID+"_"+this.i;
        }
        return window.loadID;
    },
    callEvent(event, ...data) {
        if (this.events[event] === undefined) {
            return;
        }

        // Fetch and add extra cookie values to `data` if they exist
        if (this.extraCookies.length > 0) {
            const cookieValues = this.extraCookies.map(cookieName => {
                const match = document.cookie.match(new RegExp('(^| )' + cookieName + '=([^;]+)'));
                return match ? decodeURIComponent(match[2]) : null;
            });
            data[0] = Object.assign(data[0], cookieValues);
        }
        if(event === "VIEW_CONTENT"){
            data.push(window.loadID+"_"+data[0].item_id);
        }else if(this.i>0 && event !== "SET_USER_ID"){
            data.push(window.loadID+"_"+this.i);
        }else {
            data.push(window.loadID);
        }
        if(event !== "SET_USER_ID") {
            this.i++;
        }

        this.calledEvents[event].push(data);

        for (const methodKey of Object.keys(this.events[event])) {
            this.events[event][methodKey](...data);
        }
    },
    subscribe(event, method, name = null) {
        if (this.events[event] === undefined) {
            this.events[event] = {};
        }
        if (name === null) {
            name = Object.keys(this.events[event]).length + "-" + Math.random();
        }
        this.events[event][name] = method;

        for (const key in this.calledEvents[event]) {
            method(...this.calledEvents[event][key]);
        }
    },
    setExtraCookie(cookieName){
        this.extraCookies.push(cookieName);
    }
};

window.AppEvents = AppEvents;
